export default __webpack_public_path__ + "static/media/help-rav-inv-23.b694046d.png";